import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import AdminPage from './pages/AdminPage';
import './App.css';

// Component to handle trailing slash redirects and canonical consistency
const TrailingSlashHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Remove trailing slash (except for root)
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      navigate(location.pathname.slice(0, -1) + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);

  return children;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <TrailingSlashHandler>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </TrailingSlashHandler>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;